<div
  class="flex w-[462px] flex-col gap-5 bg-surface-0 p-12 shadow-xl shadow-surface-200
    rounded-border">
  <div>
    <h3 class="mb-2 font-medium text-surface-900" i18n>Log in</h3>
    <small class="font-medium text-surface-600" i18n>
      Please enter your credentials
    </small>
  </div>

  <form class="flex flex-col gap-3" [formGroup]="loginForm">
    <p-floatlabel variant="in">
      <p-iconfield>
        <p-inputicon>
          <ng-icon
            name="phosphorEnvelopeSimple"
            class="text-xl text-primary"></ng-icon>
        </p-inputicon>
        <input
          pInputText
          id="email"
          type="text"
          fluid
          formControlName="email" />
      </p-iconfield>
      <label for="email">Email</label>
    </p-floatlabel>

    <p-floatlabel variant="in">
      <p-iconfield>
        <p-inputicon class="z-10">
          <ng-icon
            name="phosphorLockSimple"
            class="text-xl text-primary"></ng-icon>
        </p-inputicon>

        <p-password
          class="w-full"
          name="password"
          formControlName="password"
          feedback="false"
          toggleMask="true"
          fluid
          (keyup)="logIn($event)">
          <ng-template pTemplate="hideicon">
            <ng-icon
              name="phosphorEye"
              class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
          </ng-template>
          <ng-template pTemplate="showicon">
            <ng-icon
              name="phosphorEyeClosed"
              class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
          </ng-template>
        </p-password>
      </p-iconfield>
      <label for="password" i18n>Password</label>
    </p-floatlabel>
  </form>

  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <p-checkbox
        id="rememberme"
        [binary]="true"
        class="h-7"
        [(ngModel)]="checkbox"
        (onChange)="onCheckBoxChange($event)"></p-checkbox>
      <label
        for="rememberme"
        class="cursor-pointer text-sm font-medium text-surface-900"
        (click)="toggleCheckBox()"
        i18n>
        Remember me
      </label>
    </div>
    <a
      class="ml-2 cursor-pointer text-right text-sm font-medium text-surface-900 no-underline"
      (click)="navigationService.forward('/forgot-password')"
      i18n>
      Forgot password?
    </a>
  </div>

  <div class="flex min-h-7 flex-col">
    <error-small-component></error-small-component>
    <caps-lock-component></caps-lock-component>
  </div>

  <button
    pButton
    pRipple
    label="Sign In"
    class="w-full !text-sm"
    [disabled]="loginForm.invalid"
    (click)="logIn()"></button>
</div>
